// Custom Product JavaScript
// Basitleştirilmiş ve generic yapılmış versiyon

(function() {
    'use strict';

    // Variant seçimi için Swiper
    const variantSwiper = new Swiper('.swiper-product', {
        slidesPerView: 1,
        spaceBetween: 30,
        allowTouchMove: false, // Radio button ile kontrol edeceğiz
    });

    // Variant radio button değişikliği
    document.querySelectorAll('input[name="variant-select"]').forEach((radio, index) => {
        radio.addEventListener('change', function() {
            if (this.checked) {
                variantSwiper.slideTo(index);
            }
        });
    });

    // Store uploaded files for later Cloudinary upload
    const uploadedFiles = {};

    // Prevent browser extension errors
    window.addEventListener('error', function(event) {
        // Ignore browser extension errors (content.js, etc.)
        if (event.filename && (
            event.filename.includes('extension://') ||
            event.filename.includes('content.js') ||
            event.filename.includes('moz-extension://')
        )) {
            event.preventDefault();
            event.stopPropagation();
            console.log('🚫 Browser extension error ignored:', event.message);
            return false;
        }
    });

    // Dosya yükleme işlevi (with validation)
    function handleFileUpload(inputId, imageId) {
        const input = document.getElementById(inputId);
        if (!input) {
            console.warn(`⚠️ File input not found: ${inputId}`);
            return;
        }

        console.log(`✅ File upload handler attached: ${inputId} → ${imageId}`);

        input.addEventListener('change', async function() {
            if (this.files && this.files[0]) {
                const file = this.files[0];
                const variantId = inputId.replace('imgInp-', '');

                console.log(`📁 File selected for variant ${variantId}:`, file.name);

                // 🛡️ PROTECTION: Check rate limit and validate upload
                if (typeof UploadProtection !== 'undefined') {
                    const protection = await UploadProtection.validateUpload(file);
                    if (!protection.valid) {
                        UploadProtection.showRateLimitError(protection.errors);
                        this.value = ''; // Clear input
                        return;
                    }
                    
                    // Record upload start
                    UploadProtection.startUpload();
                }

                // Validate file before displaying
                if (typeof ValidationModule !== 'undefined') {
                    const validation = ValidationModule.validateImageFile(file);
                    if (!validation.isValid) {
                        ValidationModule.showErrors(validation.errors.map(err => ({
                            field: 'image',
                            message: err,
                            element: `#${inputId}`
                        })));
                        this.value = ''; // Clear input
                        
                        // End upload tracking
                        if (typeof UploadProtection !== 'undefined') {
                            UploadProtection.endUpload();
                        }
                        return;
                    }
                }

                // Store file for later upload
                uploadedFiles[variantId] = file;

                // Display image preview
                const reader = new FileReader();
                reader.onload = function(e) {
                    const img = document.getElementById(imageId);
                    if (img) {
                        img.src = e.target.result;
                        console.log(`✅ Image preview set for: ${imageId}`);
                        
                        // 🛡️ PROTECTION: Record successful upload
                        if (typeof UploadProtection !== 'undefined') {
                            UploadProtection.recordUpload(file);
                            UploadProtection.endUpload();
                            console.log('📊 Upload stats:', UploadProtection.getStats());
                        }
                    } else {
                        console.error(`❌ Image element not found: ${imageId}`);
                        
                        // End upload tracking on error
                        if (typeof UploadProtection !== 'undefined') {
                            UploadProtection.endUpload();
                        }
                    }
                };
                reader.onerror = function() {
                    console.error('❌ File read error');
                    
                    // End upload tracking on error
                    if (typeof UploadProtection !== 'undefined') {
                        UploadProtection.endUpload();
                    }
                };
                reader.readAsDataURL(file);
            }
        });
    }

    // Görsel zoom işlevi
    function handleZoom(zoomInId, zoomOutId, imageId) {
        const zoomHeightIncrement = 150; // px
        
        const zoomInBtn = document.getElementById(zoomInId);
        const zoomOutBtn = document.getElementById(zoomOutId);
        const img = document.getElementById(imageId);

        if (zoomInBtn && img) {
            zoomInBtn.addEventListener('click', function(e) {
                e.preventDefault();
                const currentHeight = img.offsetHeight || 450;
                img.style.height = (currentHeight + zoomHeightIncrement) + 'px';
            });
        }

        if (zoomOutBtn && img) {
            zoomOutBtn.addEventListener('click', function(e) {
                e.preventDefault();
                const currentHeight = img.offsetHeight || 450;
                img.style.height = Math.max(150, currentHeight - zoomHeightIncrement) + 'px';
            });
        }
    }

    // Görsel döndürme işlevi
    function handleRotate(rotateId, imageId) {
        let angle = 0;
        const rotateBtn = document.getElementById(rotateId);
        const img = document.getElementById(imageId);

        if (rotateBtn && img) {
            rotateBtn.addEventListener('click', function(e) {
                e.preventDefault();
                angle += 90;
                img.style.transform = `rotate(${angle}deg)`;
            });
        }
    }

    // Görseli sıfırlama
    function handleReset(resetId, imageId) {
        const resetBtn = document.getElementById(resetId);
        const img = document.getElementById(imageId);

        if (resetBtn && img) {
            resetBtn.addEventListener('click', function(e) {
                e.preventDefault();
                img.src = '';
                img.style.height = '450px';
                img.style.transform = 'rotate(0deg)';
            });
        }
    }

    // Text değişikliği
    function handleTextChange(textInputId, labelId) {
        const input = document.getElementById(textInputId);
        const labelSpan = document.querySelector(`#${labelId} span`);

        if (input && labelSpan) {
            input.addEventListener('keyup', function() {
                labelSpan.textContent = this.value;
                console.log('✏️ Metin güncellendi:', this.value);
            });
            
            // Input temizlendiğinde de güncelle
            input.addEventListener('input', function() {
                labelSpan.textContent = this.value;
            });
        } else {
            console.warn('⚠️ Text change handler: Element bulunamadı', {
                textInputId,
                labelId,
                inputFound: !!input,
                spanFound: !!labelSpan
            });
        }
    }

    // Pozisyon seçimi
    function handlePositionSelect(positionClass, labelId) {
        const buttons = document.querySelectorAll(`.${positionClass} .select-att`);
        const label = document.getElementById(labelId);

        buttons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                if (label) {
                    // Pozisyon class'ını güncelle ama diğer class'ları koru
                    const positionId = this.id;
                    
                    // Önce tüm pozisyon class'larını kaldır
                    label.classList.remove(
                        'arthus-top-left', 'arthus-top-right', 'arthus-bottom-left', 'arthus-bottom-right',
                        'arthus-custom-top-left', 'arthus-custom-top-right', 'arthus-custom-bottom-left', 'arthus-custom-bottom-right',
                        'bond-top-left', 'bond-top-right', 'bond-bottom-left', 'bond-bottom-right',
                        'arthus-boy-top-left', 'arthus-boy-top-right', 'arthus-boy-bottom-left', 'arthus-boy-bottom-right'
                    );
                    
                    // Yeni pozisyon class'ını ekle
                    label.classList.add(positionId);
                    
                    console.log('📍 Pozisyon değiştirildi:', positionId);
                }
            });
        });
    }

    // Renk seçimi
    function handleColorSelect(colorClass, labelId) {
        const buttons = document.querySelectorAll(`.${colorClass} .select-att`);
        const labelSpan = document.querySelector(`#${labelId} span`);

        buttons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                if (labelSpan) {
                    labelSpan.className = this.id;
                }
            });
        });
    }

    // Draggable yapma (jQuery UI gerekli)
    if (typeof $ !== 'undefined' && $.fn.draggable) {
        $('.draggableHelper').draggable();
    }

    // Her variant için işlevleri başlat
    // Dinamik olarak sayfadaki tüm variant ID'lerini al
    const variantRadios = document.querySelectorAll('input[name="variant-select"]');
    const variants = Array.from(variantRadios).map(radio => radio.value);
    
    console.log('🔍 Bulunan variant ID\'leri:', variants);
    
    variants.forEach(variantId => {
        handleFileUpload(`imgInp-${variantId}`, `custom-image-${variantId}`);
        handleZoom(`zoom-in-${variantId}`, `zoom-out-${variantId}`, `custom-image-${variantId}`);
        handleRotate(`rotate-image-${variantId}`, `custom-image-${variantId}`);
        handleReset(`reset-iamge-${variantId}`, `custom-image-${variantId}`);
        handleTextChange(`customise-short-text-${variantId}`, `customise-text-${variantId}`);
        handlePositionSelect(`position-select-${variantId}`, `customise-text-${variantId}`);
        handleColorSelect(`color-select-${variantId}`, `customise-text-${variantId}`);
    });

    // Mobile slider için
    function isMobile() {
        return window.innerWidth <= 768;
    }

    if (isMobile()) {
        const mobileSwiper = new Swiper('.custom-three-swiper-container', {
            direction: 'horizontal',
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    // Toggle button functionality (Dropdown)
    const toggleButtons = document.querySelectorAll('.toggle-button');
    const toggleDivs = document.querySelectorAll('.toggle-div');
    const toggleButtonColors = document.querySelectorAll('.toggle-button-color');
    const toggleDivColors = document.querySelectorAll('.toggle-div-color');

    toggleButtons.forEach((toggleButton, index) => {
        toggleButton.addEventListener('click', () => {
            toggleDivs[index].classList.toggle('show');
        });

        document.addEventListener('click', (event) => {
            const target = event.target;
            if (!target.matches('.toggle-button') && !target.matches('.toggle-div *')) {
                toggleDivs[index].classList.remove('show');
            }
        });

        toggleDivs[index].addEventListener('click', (event) => {
            const target = event.target;
            if (target.matches('.select-att')) {
                toggleButton.value = target.textContent;
            }
            event.stopPropagation();
        });
    });

    toggleButtonColors.forEach((toggleButtonColor, index) => {
        toggleButtonColor.addEventListener('click', () => {
            toggleDivColors[index].classList.toggle('show');
        });

        document.addEventListener('click', (event) => {
            const target = event.target;
            if (!target.matches('.toggle-button-color') && !target.matches('.toggle-div-color *')) {
                toggleDivColors[index].classList.remove('show');
            }
        });

        toggleDivColors[index].addEventListener('click', (event) => {
            const target = event.target;
            if (target.matches('.select-att')) {
                toggleButtonColor.value = target.textContent;
            }
            event.stopPropagation();
        });
    });

    // ========================================
    // SEPETE EKLE FONKSİYONU (Console logging - kept for debugging)
    // ========================================
    
    function captureProductData(variantId) {
        return new Promise((resolve, reject) => {
            // Variant bilgilerini topla
            const variantData = {
                variantId: variantId,
                timestamp: new Date().toISOString(),
            };

            // Variant adını al
            const selectedRadio = document.querySelector(`input[name="variant-select"][value="${variantId}"]:checked`);
            if (selectedRadio) {
                const variantLabel = selectedRadio.nextElementSibling;
                variantData.variantName = variantLabel.querySelector('.variant-name')?.textContent || '';
                variantData.variantDescription = variantLabel.querySelector('.variant-desc')?.textContent || '';
            }

            // Fiyatı al
            const priceElement = document.getElementById(`price-value-${variantId}`);
            variantData.price = priceElement ? priceElement.textContent.trim() : '';

            // Yüklenen görseli al
            const uploadedImage = document.getElementById(`custom-image-${variantId}`);
            variantData.uploadedImage = {
                src: uploadedImage ? uploadedImage.src : null,
                width: uploadedImage ? uploadedImage.offsetWidth : null,
                height: uploadedImage ? uploadedImage.offsetHeight : null,
                transform: uploadedImage ? uploadedImage.style.transform : null
            };

            // Metin bilgilerini al
            const textInput = document.getElementById(`customise-short-text-${variantId}`);
            const textLabel = document.getElementById(`customise-text-${variantId}`);
            variantData.customText = {
                text: textInput ? textInput.value : '',
                position: textLabel ? textLabel.className : '',
                color: textLabel ? textLabel.querySelector('span')?.className : ''
            };

            // Pozisyon seçimini al
            const positionInput = document.querySelector(`.position-${variantId}`);
            variantData.textPosition = positionInput ? positionInput.value : '';

            // Renk seçimini al
            const colorInput = document.querySelector(`.color-${variantId}`);
            variantData.textColor = colorInput ? colorInput.value : '';

            // Beden seçimini al
            let selectedSize = null;
            const sizeInputs = document.querySelectorAll(`input[name^="product_attribute_"]:checked`);
            sizeInputs.forEach(input => {
                const label = document.querySelector(`label[for="${input.id}"]`);
                if (label) {
                    selectedSize = label.textContent.trim();
                }
            });
            variantData.selectedSize = selectedSize;

            // html2canvas ile ürün görselini yakala
            const backImage = document.querySelector(`#variant-${variantId} #backImage`);
            
            if (backImage && typeof Html2CanvasFix !== 'undefined') {
                // Use enhanced capture with background fix
                Html2CanvasFix.captureWithBackgroundFix(backImage, {
                    logging: true
                }).then(canvas => {
                    variantData.renderedImage = {
                        dataUrl: canvas.toDataURL('image/png'),
                        width: canvas.width,
                        height: canvas.height
                    };
                    console.log('✅ Görsel yakalandı (background-image dahil)');
                    resolve(variantData);
                }).catch(error => {
                    console.error('html2canvas hatası:', error);
                    variantData.renderedImage = null;
                    resolve(variantData);
                });
            } else if (backImage && typeof html2canvas !== 'undefined') {
                // Fallback to regular html2canvas
                html2canvas(backImage, {
                    backgroundColor: null,
                    scale: 2,
                    logging: true,
                    useCORS: true,
                    allowTaint: true
                }).then(canvas => {
                    variantData.renderedImage = {
                        dataUrl: canvas.toDataURL('image/png'),
                        width: canvas.width,
                        height: canvas.height
                    };
                    resolve(variantData);
                }).catch(error => {
                    console.error('html2canvas hatası:', error);
                    variantData.renderedImage = null;
                    resolve(variantData);
                });
            } else {
                variantData.renderedImage = null;
                resolve(variantData);
            }
        });
    }


    // ========================================
    // SHOPIFY ENTEGRASYONU - SEPETE EKLE
    // ========================================
    
    /**
     * Main add to cart handler with Cloudinary upload and Shopify integration
     */
    async function handleAddToCart(variantId) {
        try {
            console.log(`🛒 handleAddToCart called with variantId: ${variantId}`);
            
            // Get product ID from button
            const button = document.querySelector(`.add-to-cart-button[data-variantid="${variantId}"]`);
            const productId = button ? button.getAttribute('data-productid') : variantId;
            
            console.log(`   Product ID: ${productId}`);
            console.log(`   Variant ID: ${variantId}`);
            
            // 1. VALIDATION
            if (typeof ValidationModule === 'undefined') {
                throw new Error('Validation module not loaded');
            }

            const validation = ValidationModule.validateProduct(variantId);
            if (!validation.isValid) {
                ValidationModule.showErrors(validation.errors);
                return;
            }

            // Show loading overlay
            ValidationModule.showLoading('Preparing product...');

            // Get selected size
            let selectedSize = null;
            const sizeInputs = document.querySelectorAll(`input[name^="product_attribute_"]:checked`);
            sizeInputs.forEach(input => {
                const label = document.querySelector(`label[for="${input.id}"]`);
                if (label) {
                    selectedSize = label.textContent.trim();
                }
            });

            if (!selectedSize) {
                throw new Error('Size selection not found');
            }

            // Get variant info
            const selectedRadio = document.querySelector(`input[name="variant-select"][value="${variantId}"]:checked`);
            let variantName = '';
            if (selectedRadio) {
                const variantLabel = selectedRadio.nextElementSibling;
                variantName = variantLabel.querySelector('.variant-name')?.textContent || '';
            }

            // 2. UPLOAD ORIGINAL IMAGE TO CLOUDINARY
            ValidationModule.updateLoadingProgress(10, 'Uploading original image...');
            
            let originalImageUrl = null;
            if (uploadedFiles[variantId]) {
                if (typeof CloudinaryUpload === 'undefined') {
                    throw new Error('Cloudinary module not loaded');
                }

                try {
                    originalImageUrl = await CloudinaryUpload.uploadWithRetry(
                        uploadedFiles[variantId],
                        'original',
                        (progress) => {
                            ValidationModule.updateLoadingProgress(10 + (progress * 0.3));
                        }
                    );
                } catch (error) {
                    console.error('Original image upload error:', error);
                    throw new Error('Image upload failed: ' + error.message);
                }
            }

            // 3. RENDER WITH HTML2CANVAS
            ValidationModule.updateLoadingProgress(40, 'Rendering product image...');
            
            const backImage = document.querySelector(`#variant-${variantId} #backImage`);
            let renderedCanvas = null;
            
            if (backImage && typeof Html2CanvasFix !== 'undefined') {
                try {
                    // Use the enhanced capture with background fix
                    renderedCanvas = await Html2CanvasFix.captureWithBackgroundFix(backImage, {
                        logging: false
                    });
                    console.log('✅ Görsel yakalandı (background-image dahil)');
                } catch (error) {
                    console.error('html2canvas error:', error);
                    throw new Error('Failed to render product image');
                }
            } else if (backImage && typeof html2canvas !== 'undefined') {
                // Fallback to regular html2canvas
                try {
                    renderedCanvas = await html2canvas(backImage, {
                        backgroundColor: null,
                        scale: 2,
                        logging: false,
                        useCORS: true,
                        allowTaint: true
                    });
                } catch (error) {
                    console.error('html2canvas error:', error);
                    throw new Error('Failed to render product image');
                }
            }

            // 4. UPLOAD RENDERED IMAGE TO CLOUDINARY
            ValidationModule.updateLoadingProgress(50, 'Uploading customized image...');
            
            let renderedImageUrl = null;
            if (renderedCanvas) {
                try {
                    renderedImageUrl = await CloudinaryUpload.uploadWithRetry(
                        renderedCanvas,
                        'rendered',
                        (progress) => {
                            ValidationModule.updateLoadingProgress(50 + (progress * 0.3));
                        }
                    );
                } catch (error) {
                    console.error('Rendered image upload error:', error);
                    throw new Error('Failed to upload customized image');
                }
            }

            // 5. PREPARE CUSTOM DATA
            const textInput = document.getElementById(`customise-short-text-${variantId}`);
            const positionInput = document.querySelector(`.position-${variantId}`);
            const colorInput = document.querySelector(`.color-${variantId}`);

            const customData = {
                originalImageUrl: originalImageUrl,
                renderedImageUrl: renderedImageUrl,
                customText: textInput ? textInput.value.trim() : '',
                textPosition: positionInput ? positionInput.value : '',
                textColor: colorInput ? colorInput.value : '',
                variantName: variantName
            };

            // 6. ADD TO SHOPIFY CART
            ValidationModule.updateLoadingProgress(80, 'Adding to cart...');
            
            if (typeof ShopifyCart === 'undefined') {
                throw new Error('Shopify Cart module not loaded');
            }

            // Get product handle from button
            const productHandle = button ? button.getAttribute('data-producthandle') : null;
            if (!productHandle) {
                throw new Error('Product handle not found');
            }

            console.log(`   Product Handle: ${productHandle}`);

            try {
                await ShopifyCart.addCustomProductToCart(productHandle, selectedSize, customData);
            } catch (error) {
                console.error('Add to cart error:', error);
                throw new Error('Failed to add to cart: ' + error.message);
            }

            // 7. SUCCESS
            ValidationModule.updateLoadingProgress(100, 'Success!');
            ValidationModule.hideLoading();
            ValidationModule.showSuccessMessage('Product added to cart!');

            // Update cart count
            if (ShopifyCart.updateCartCountDisplay) {
                await ShopifyCart.updateCartCountDisplay();
            }

            // Log to console for debugging
            console.log('✅ Product added to cart:', customData);

            // Redirect to cart after 1.5 seconds
            setTimeout(() => {
                ShopifyCart.redirectToCart();
            }, 1500);

        } catch (error) {
            console.error('Add to cart error:', error);
            ValidationModule.hideLoading();
            ValidationModule.showErrors([{
                field: 'general',
                message: error.message || 'An error occurred. Please try again.'
            }]);
        }
    }

    // Sepete ekle butonlarına event listener ekle
    document.querySelectorAll('.add-to-cart-button').forEach(button => {
        button.addEventListener('click', async function(e) {
            e.preventDefault();
            
            // Önce data-variantid'yi kontrol et, yoksa data-productid'yi kullan
            const variantId = this.getAttribute('data-variantid') || this.getAttribute('data-productid');
            
            console.log('🛒 Add to cart clicked for variant:', variantId);
            
            // Call the main handler
            await handleAddToCart(variantId);
        });
    });

})();
